module.exports = __webpack_public_path__ + "img/nek.3a26bc86.jpeg";